export class NativeStreamProbeSamplingReport {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "rowsIn",
            "baseName": "rowsIn",
            "type": "number",
            "format": ""
        },
        {
            "name": "rowsOut",
            "baseName": "rowsOut",
            "type": "number",
            "format": ""
        },
        {
            "name": "subjectRows",
            "baseName": "subjectRows",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "keptSubjectRows",
            "baseName": "keptSubjectRows",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "droppedAsNoiseRows",
            "baseName": "droppedAsNoiseRows",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "holdoutRows",
            "baseName": "holdoutRows",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "segmentKeys",
            "baseName": "segmentKeys",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStreamProbeSamplingReport.attributeTypeMap;
    }
    constructor() {
    }
}
